import { c as _c } from "react/compiler-runtime";
import FilterButton from '@/components/modules/ListOptionsBar/FilterButton';
import FilterModal from '@/components/modules/ListOptionsBar/FilterModal';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { OccasionCheckBox } from '@winelidays/wld-tsx-2/fields';
import { ModalContent } from '@winelidays/wld-tsx-2/modules';
import { isEqual } from '@winelidays/wld-tsx-2/utils';
import { useEffect, useState } from 'react';
import useReviewsOccasionFilter from '../../context/useReviewsOccasionFilter';
const OccasionFilter = t0 => {
    const $ = _c(36);
    const { formId, disabled } = t0;
    const translate = useTranslate();
    const { selectedOccasions, occasionOptions, setOccasionOptions } = useReviewsOccasionFilter();
    const hasSelection = selectedOccasions.length > 0;
    let t1;
    if ($[0] !== translate) {
        t1 = translate("messages.occasion", {
            count: 1
        });
        $[0] = translate;
        $[1] = t1;
    }
    else {
        t1 = $[1];
    }
    const filterName = t1;
    let t2;
    if ($[2] !== selectedOccasions[0] || $[3] !== selectedOccasions.length || $[4] !== translate) {
        t2 = translate("review.occasion_filter.label", {
            count: selectedOccasions.length,
            occasionName: selectedOccasions.length === 1 ? translate(`review.occasion.${selectedOccasions[0]}`) : ""
        });
        $[2] = selectedOccasions[0];
        $[3] = selectedOccasions.length;
        $[4] = translate;
        $[5] = t2;
    }
    else {
        t2 = $[5];
    }
    const btnLabel = t2;
    const [isOpen, setIsOpen] = useState(false);
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = () => {
            setIsOpen(true);
        };
        $[6] = t3;
    }
    else {
        t3 = $[6];
    }
    const handleOpen = t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = () => {
            setIsOpen(false);
        };
        $[7] = t4;
    }
    else {
        t4 = $[7];
    }
    const handleClose = t4;
    const [localValues, setLocalValues] = useState(occasionOptions);
    let t5;
    let t6;
    if ($[8] !== occasionOptions) {
        t5 = () => {
            setLocalValues(occasionOptions);
        };
        t6 = [occasionOptions];
        $[8] = occasionOptions;
        $[9] = t5;
        $[10] = t6;
    }
    else {
        t5 = $[9];
        t6 = $[10];
    }
    useEffect(t5, t6);
    let t7;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = e => {
            setLocalValues(c => {
                const newOptions = {
                    ...c
                };
                newOptions[e.target.name] = e.target.checked;
                return newOptions;
            });
        };
        $[11] = t7;
    }
    else {
        t7 = $[11];
    }
    const handleCheckBoxChange = t7;
    let t8;
    if ($[12] !== formId || $[13] !== localValues || $[14] !== translate) {
        let t9;
        if ($[16] !== formId || $[17] !== translate) {
            t9 = t10 => {
                const [key, checked] = t10;
                return <OccasionCheckBox formId={formId} key={key} occasion={key} checked={checked} onChange={handleCheckBoxChange} translate={translate}/>;
            };
            $[16] = formId;
            $[17] = translate;
            $[18] = t9;
        }
        else {
            t9 = $[18];
        }
        t8 = Object.entries(localValues).map(t9);
        $[12] = formId;
        $[13] = localValues;
        $[14] = translate;
        $[15] = t8;
    }
    else {
        t8 = $[15];
    }
    const modalContent = t8;
    let t9;
    if ($[19] !== localValues || $[20] !== setOccasionOptions) {
        t9 = () => {
            setOccasionOptions(localValues);
            handleClose();
        };
        $[19] = localValues;
        $[20] = setOccasionOptions;
        $[21] = t9;
    }
    else {
        t9 = $[21];
    }
    const handleApply = t9;
    let t10;
    if ($[22] !== setOccasionOptions) {
        t10 = () => {
            setOccasionOptions(_temp);
            handleClose();
        };
        $[22] = setOccasionOptions;
        $[23] = t10;
    }
    else {
        t10 = $[23];
    }
    const handleReset = t10;
    const localSelectedOccasions = Object.entries(localValues).filter(_temp2).map(_temp3);
    const hasOneChecked = localSelectedOccasions.length > 0;
    const hasDiffWithActive = !isEqual(localSelectedOccasions.sort(), selectedOccasions.sort());
    let t11;
    if ($[24] !== btnLabel || $[25] !== disabled || $[26] !== filterName || $[27] !== handleApply || $[28] !== handleReset || $[29] !== hasDiffWithActive || $[30] !== hasOneChecked || $[31] !== hasSelection || $[32] !== isOpen || $[33] !== localValues || $[34] !== modalContent) {
        t11 = localValues ? <><FilterModal filterName={filterName} isOpen={isOpen} onClose={handleClose} onApply={handleApply} hasDiffWithActive={hasDiffWithActive} hasDiffWithInitial={hasOneChecked} onReset={handleReset}><ModalContent>{modalContent}</ModalContent></FilterModal><FilterButton title={btnLabel} onClick={handleOpen} isActive={hasSelection} onReset={handleReset} disabled={disabled}>{btnLabel}</FilterButton></> : null;
        $[24] = btnLabel;
        $[25] = disabled;
        $[26] = filterName;
        $[27] = handleApply;
        $[28] = handleReset;
        $[29] = hasDiffWithActive;
        $[30] = hasOneChecked;
        $[31] = hasSelection;
        $[32] = isOpen;
        $[33] = localValues;
        $[34] = modalContent;
        $[35] = t11;
    }
    else {
        t11 = $[35];
    }
    return t11;
};
export default OccasionFilter;
function _temp(c_0) {
    const n = {
        ...c_0
    };
    for (const key_0 in n) {
        n[key_0] = false;
    }
    return n;
}
function _temp2(t0) {
    const [, checked_0] = t0;
    return !!checked_0;
}
function _temp3(t0) {
    const [occasion] = t0;
    return occasion;
}
